import { callMBankBridge } from 'shared/lib/mbank-bridge'

export const requestAuthRequired = async (
  redirectUrl?: string,
): Promise<boolean> => {
  const response = await callMBankBridge(
    'auth.required',
    redirectUrl ? { redirectUrl } : {},
  )

  if (response.ok) return true

  return false
}
